import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withKeys as _withKeys, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './assets/oneteg-new-logo.png'


const _withScopeId = n => (_pushScopeId("data-v-19577778"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "login-bg" }, null, -1))
const _hoisted_2 = { class: "login" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "height-10" }, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "logo",
    class: "logo",
    src: _imports_0
  })
], -1))
const _hoisted_4 = { class: "d-flex justify-content-center align-items-center flex-column height-90" }
const _hoisted_5 = { class: "login-page" }
const _hoisted_6 = { class: "d-flex align-items-center justify-content-center login-page login-form" }
const _hoisted_7 = ["src"]
const _hoisted_8 = {
  key: 0,
  class: "divider-container"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "or-text" }, "OR", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_12 = [
  _hoisted_9,
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = { class: "label-box min-width" }
const _hoisted_14 = {
  key: 0,
  class: "login-loader"
}
const _hoisted_15 = { class: "loader-div-40" }
const _hoisted_16 = ["src"]

import { onMounted, onUnmounted, ref, watchEffect } from "vue";
import {
  ElButton,
  ElForm,
  ElFormItem,
  ElInput,
  ElOption,
  ElSelect,
} from "element-plus";
import i18n from "@/core/i18n/i18n";
import { currentRoute, router } from "@/core/router";
import { changeLocale } from "@/core/i18n";
import {
  isUserLoggedIn,
  loginUsernamePassword,
  retrieveOAuth2Registrations,
} from "@/core/auth";
import { showAlert } from "@/core/popup";
import { ASSETS_BASE_URL, DEFAULT_LOGO } from "@/core/logo";
import GoogleIcon from "@/core/layout/assets/google-brands.svg";
import OktaIcon from "@/core/layout/assets/okta-brands.svg";
import MicrosoftIcon from "@/core/layout/assets/microsoft-brands.svg";
import SsoDefaultIcon from "@/core/layout/assets/sso-default.svg";
import { TYPE } from "vue-toastification";


export default /*#__PURE__*/_defineComponent({
  __name: 'Login',
  setup(__props) {

const iconMap = {
  google: GoogleIcon,
  okta: OktaIcon,
  microsoft: MicrosoftIcon,
};

const { t } = i18n.global;

const loading = ref(false);

const formUser = ref({
  username: "",
  password: "",
});

const formRules = ref({
  username: [
    {
      required: false,
      message: t("Auth.InputUser"),
      trigger: "blur",
    },
    {
      type: "email",
      message: t("Auth.EmailVal"),
      trigger: "blur",
    },
  ],
  password: {
    required: false,
    message: t("Auth.PasswordVal"),
    trigger: "blur",
  },
});

const validValue = ref(false);

const elForm = ref<InstanceType<typeof ElForm>>();

const observer = ref();

const oauth2Registrations = ref([]);

const loginPassword = ref();
onMounted(() => {
  if (isUserLoggedIn.value) {
    router.push("/");
  }
  observer.value = new MutationObserver(() => {
    const viewIcon = loginPassword.value.$el.querySelector(".el-icon-view");
    if (viewIcon) {
      viewIcon.setAttribute("id", "login-password-show-icon");
      viewIcon.setAttribute("test-id", "login-password-show-icon");
    }
  });
  observer.value.observe(loginPassword.value.$el, {
    subtree: true,
    childList: true,
  });
  (async () => {
    const list = await retrieveOAuth2Registrations();
    oauth2Registrations.value = list;
    console.log(list);
  })();
});
onUnmounted(() => {
  observer.value.disconnect();
});
const redirectToReset = () => {
  router.push("reset-password");
};

const handleLogin = async (form) => {
  console.log("Handle login");
  loading.value = true;
  formRules.value.password.required = true;
  formRules.value.username[0].required = true;
  form.validate(async (valid) => {
    validValue.value = valid;
    if (valid) {
      const loginResponse = await loginUsernamePassword(
        formUser.value.username,
        formUser.value.password
      );

      if (loginResponse) {
        if (loginResponse.otpValidationRequired) {
          await router.push("otp-setup");
        } else {
          await router.push("auth/login-using-session");
          showAlert(TYPE.SUCCESS, t("Common.WelcomeToOneTeg"));
        }
      }

      loading.value = false;
    }
    loading.value = false;
    return false;
  });
  formRules.value.password.required = false;
  formRules.value.username[0].required = false;
};

const handleOAuth2Login = async (
  form: InstanceType<typeof ElForm>,
  url: string
) => {
  window.location.href = url;
  return false;
};

const selectedLocale = ref(currentRoute.value.params.locale as string);

watchEffect(() => changeLocale(selectedLocale.value));

return (_ctx: any,_cache: any) => {
  const _component_ElIcon = _resolveComponent("ElIcon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_unref(ElForm), {
              ref_key: "elForm",
              ref: elForm,
              model: formUser.value,
              rules: formRules.value,
              "label-position": "top"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(oauth2Registrations.value, (item) => {
                  return (_openBlock(), _createBlock(_unref(ElFormItem), {
                    class: "d-flex flex-column align-items-center justify-content-center sso-button",
                    key: item.clientName
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(ElButton), {
                        loading: loading.value,
                        class: "width-350",
                        type: "plain",
                        onClick: ($event: any) => (handleOAuth2Login(elForm.value, item.url))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ElIcon, { style: {"margin-right":"12px"} }, {
                            default: _withCtx(() => [
                              _createElementVNode("img", {
                                src: iconMap[item.icon] || _unref(SsoDefaultIcon),
                                alt: "Icon",
                                width: "20px",
                                height: "20px"
                              }, null, 8, _hoisted_7)
                            ]),
                            _: 2
                          }, 1024),
                          _createTextVNode(" " + _toDisplayString(_unref(t)("Common.LoginWith")) + " " + _toDisplayString(item.clientName), 1)
                        ]),
                        _: 2
                      }, 1032, ["loading", "onClick"])
                    ]),
                    _: 2
                  }, 1024))
                }), 128)),
                (oauth2Registrations.value.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_12))
                  : _createCommentVNode("", true),
                _createVNode(_unref(ElFormItem), {
                  prop: "username",
                  label: _unref(t)('Common.Email')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(ElInput), {
                      modelValue: formUser.value.username,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formUser.value.username) = $event)),
                      id: "login-username",
                      class: "min-width",
                      onKeydown: _cache[1] || (_cache[1] = _withKeys(_withModifiers(($event: any) => (handleLogin(elForm.value)), ["prevent"]), ["enter"]))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_unref(ElFormItem), {
                  prop: "password",
                  "status-icon": "true",
                  label: _unref(t)('Common.Password')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(ElInput), {
                      ref_key: "loginPassword",
                      ref: loginPassword,
                      modelValue: formUser.value.password,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formUser.value.password) = $event)),
                      id: "login-password",
                      "show-password": "",
                      class: "min-width",
                      type: "password",
                      onKeydown: _cache[3] || (_cache[3] = _withKeys(_withModifiers(($event: any) => (handleLogin(elForm.value)), ["prevent"]), ["enter"]))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_unref(ElFormItem), {
                  label: _unref(t)('Common.Language')
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_13, [
                      _createVNode(_unref(ElSelect), {
                        modelValue: selectedLocale.value,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((selectedLocale).value = $event)),
                        id: "login-language",
                        class: "edge-corner"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(ElOption), {
                            label: "English",
                            id: "login-eng-option",
                            value: "en"
                          }),
                          _createVNode(_unref(ElOption), {
                            label: "Türkçe",
                            id: "login-tr-option",
                            value: "tr"
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_unref(ElFormItem), { class: "d-flex flex-column align-items-center justify-content-center" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(ElButton), {
                      id: "login-submit-button",
                      loading: loading.value,
                      class: "btn-primary submit-button",
                      type: "primary",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (handleLogin(elForm.value)))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)("Login")), 1)
                      ]),
                      _: 1
                    }, 8, ["loading"])
                  ]),
                  _: 1
                }),
                _createVNode(_unref(ElFormItem), { class: "d-flex flex-column align-items-right justify-content-center" }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", {
                      class: "forgotPasswordText",
                      id: "login-forgot-pw",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (redirectToReset()))
                    }, _toDisplayString(_unref(t)("Common.ForgotPassword")), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model", "rules"]),
            (loading.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("img", {
                      src: `${_unref(ASSETS_BASE_URL)}/${_unref(DEFAULT_LOGO)}.png`,
                      alt: "Loading...",
                      class: "loader-logo-40"
                    }, null, 8, _hoisted_16)
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ], 64))
}
}

})